const primary = "6fcebb194d7c4d65b8a0b55044577dd0";

export default primary;